// extracted by mini-css-extract-plugin
export var animationContainer = "_bh-0";
export var asteriskIcon = "_bh-8";
export var conversationLeftSection = "_bh-4";
export var conversationListItem = "_bh-3";
export var conversationMiddleSection = "_bh-5";
export var conversationRightSection = "_bh-6";
export var detailsContent = "_bh-1";
export var listContainer = "_bh-7";
export var modalContent = "_bh-2";